var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntercambios(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "182px",
    height: "64px",
    viewBox: "0 0 182 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Intercambios") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 63.6 58.3774151 63.6 58.3774151 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "49.7278543 49.9996444 0.297785521 49.9996444 0.297785521 0.299731911 49.7278543 0.299731911"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-2",
    transform: "translate(-422.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Intercambios",
    transform: "translate(422.156250, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M116.96087,42.4 L81.7165488,42.6053861 L81.7165488,37.5238424 C81.7165488,37.2211773 81.5733773,37.0020444 81.287865,36.8658869 C81.001799,36.7450436 80.7384409,36.7904295 80.4980679,37.0020444 L71.8341146,45.0325541 C71.683743,45.1840258 71.6086957,45.3655692 71.6086957,45.5771842 C71.6086957,45.7737633 71.683743,45.9477888 71.8341146,46.0989821 L80.4980679,54.0389985 C80.7387178,54.2355777 81.0020759,54.273724 81.287865,54.1523239 C81.5733773,54.0314806 81.7165488,53.8123477 81.7165488,53.4946468 L81.7165488,48.4131032 L116.961146,48.2077171 C117.171888,48.2077171 117.344691,48.1394991 117.480109,48.0036201 C117.615249,47.867741 117.68282,47.6939939 117.68282,47.4821005 L117.68282,43.1261735 C117.683096,42.9145585 117.615249,42.7402546 117.479832,42.6040971 C117.344414,42.4679395 117.171611,42.4 116.96087,42.4 Z",
    id: "Flecha",
    fill: "#00C5AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.96087,15.2 L81.7165488,15.4053861 L81.7165488,10.3238424 C81.7165488,10.0211773 81.5733773,9.80204444 81.287865,9.66588692 C81.001799,9.54504363 80.7384409,9.59042947 80.4980679,9.80204444 L71.8341146,17.8325541 C71.683743,17.9840258 71.6086957,18.1655692 71.6086957,18.3771842 C71.6086957,18.5737633 71.683743,18.7477888 71.8341146,18.8989821 L80.4980679,26.8389985 C80.7387178,27.0355777 81.0020759,27.073724 81.287865,26.9523239 C81.5733773,26.8314806 81.7165488,26.6123477 81.7165488,26.2946468 L81.7165488,21.2131032 L116.961146,21.0077171 C117.171888,21.0077171 117.344691,20.9394991 117.480109,20.8036201 C117.615249,20.667741 117.68282,20.4939939 117.68282,20.2821005 L117.68282,15.9261735 C117.683096,15.7145585 117.615249,15.5402546 117.479832,15.4040971 C117.344414,15.2679395 117.171611,15.2 116.96087,15.2 Z",
    id: "Flecha",
    fill: "#00C5AD",
    transform: "translate(94.645758, 18.310833) rotate(-180.000000) translate(-94.645758, -18.310833) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Camisa"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#FFD356",
    points: "8.42145936 61.2922286 49.9553677 61.2922286 49.9553677 5.77912 8.42145936 5.77912"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#FFD356",
    points: "22.4480115 5.77912 35.9294036 5.77912 35.9294036 0 22.4480115 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#17374C",
    points: "22.4478939 -0.000181714285 16.8345678 5.77893829 16.8345678 13.8743097 22.4478939 13.8743097"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#17374C",
    points: "35.9292272 -0.000181714285 35.9292272 13.8743097 41.5431413 13.8743097 41.5431413 5.77893829"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#FFB842",
    points: "22.4479527 5.77912 22.4479527 13.8738857 24.4092353 13.8738857 29.1886488 18.8044 33.9662979 13.8738857 35.9293448 13.8738857 35.9293448 5.77912"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#17374C",
    points: "26.877511 7.48117714 31.4999042 7.48117714 31.4999042 5.77912 26.877511 5.77912"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#FFD356",
    points: "32.5602318 16.5784 35.9294036 16.5784 35.9294036 13.8738857 32.5602318 13.8738857"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#FFD356",
    points: "29.1885899 20.8113737 27.5025338 19.0747909 32.5601141 13.874128 35.929286 13.874128"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#FFD356",
    points: "27.5024162 19.0746697 29.1884723 17.3411154 25.8169481 13.8740069 22.4477763 13.8740069"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#FFC743",
    points: "29.1885899 26.9229097 25.8170657 26.9229097 25.8170657 13.8740069 29.1885899 17.3411154"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.06122,20.351152 C28.06122,20.6673349 27.8101053,20.9265806 27.5025338,20.9265806 C27.1961385,20.9265806 26.9485523,20.6673349 26.9485523,20.351152 C26.9485523,20.0234606 27.1961385,19.7611863 27.5025338,19.7611863 C27.8101053,19.7611863 28.06122,20.0234606 28.06122,20.351152 Z",
    id: "Fill-11",
    fill: "#17374C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.06122,23.9192331 C28.06122,24.239656 27.8101053,24.4989017 27.5025338,24.4989017 C27.1961385,24.4989017 26.9485523,24.239656 26.9485523,23.9192331 C26.9485523,23.603656 27.1961385,23.3486503 27.5025338,23.3486503 C27.8101053,23.3486503 28.06122,23.603656 28.06122,23.9192331",
    id: "Fill-13",
    fill: "#17374C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,19.6620309 L8.42145936,19.6620309 L8.42145936,5.77905943 C6.26787108,5.77905943 4.10546144,6.63190514 2.46880491,8.321848 C0.823327032,10.0087623 0,12.235368 0,14.4577337 L0,19.6620309 Z",
    id: "Fill-15",
    fill: "#FFB842"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-18"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-17",
    fill: "#17374C",
    mask: "url(#mask-2)",
    points: "0 21.97592 8.42145936 21.97592 8.42145936 19.6620914 0 19.6620914"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-19",
    fill: "#17374C",
    mask: "url(#mask-2)",
    points: "8.42145936 63.6 49.9553677 63.6 49.9553677 61.2922286 8.42145936 61.2922286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9555441,19.6620309 L58.3770035,19.6620309 L58.3770035,14.4577337 C58.3770035,12.235368 57.5536764,10.0087623 55.9087866,8.321848 C54.2709539,6.63190514 52.1097205,5.77905943 49.9555441,5.77905943 L49.9555441,19.6620309 Z",
    id: "Fill-20",
    fill: "#FFB842",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-21",
    fill: "#17374C",
    mask: "url(#mask-2)",
    points: "49.9559558 21.97592 58.3774151 21.97592 58.3774151 19.6620914 49.9559558 19.6620914"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-22",
    fill: "#17374C",
    mask: "url(#mask-2)",
    points: "33.9569473 26.9227886 45.1824233 26.9227886 45.1824233 25.77072 33.9569473 25.77072"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-23",
    fill: "#F6F9FC",
    mask: "url(#mask-2)",
    points: "33.9569473 25.77072 45.1824233 25.77072 45.1824233 23.4593143 33.9569473 23.4593143"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Bal\\xF3n",
    transform: "translate(128.895652, 4.800000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.902029,26.5955556 C52.902029,41.2832171 41.0593808,53.1911111 26.4510145,53.1911111 C11.8426482,53.1911111 0,41.2832171 0,26.5955556 C0,11.9073621 11.8426482,0 26.4510145,0 C41.0593808,0 52.902029,11.9073621 52.902029,26.5955556",
    id: "Fill-1",
    fill: "#FF7057"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(3.174122, 3.191467)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3722081,0.299731911 C38.5766357,4.18215111 39.8436392,8.67414044 39.8436392,13.4650638 C39.8436392,28.1543211 28.000991,40.0616832 13.3926248,40.0616832 C8.62720998,40.0616832 4.15963364,38.7866923 0.297785521,36.5696868 C4.85265022,44.5903744 13.4333593,49.9999104 23.2768399,49.9999104 C37.8852061,49.9999104 49.7278543,38.0920164 49.7278543,23.4043548 C49.7278543,13.5076167 44.347718,4.87948658 36.3722081,0.299731911",
    id: "Fill-3",
    fill: "#FF543C",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    fill: "#F6F9FC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.1166878,6.17048804 L43.2589942,6.05931861 C42.8759836,5.7428315 42.4818634,5.43964217 42.0819241,5.1444315 C35.6865978,10.2162039 31.9522436,17.7246612 31.7411645,25.8682203 L27.1741323,25.8682203 L27.1741323,0.0184041244 C26.9334281,0.01148928 26.6937819,-0.000212764445 26.4509616,-0.000212764445 C26.2086703,-0.000212764445 25.9684951,0.01148928 25.7277909,0.0184041244 L25.7277909,25.8682203 L21.1607587,25.8682203 C20.9496796,17.7251931 17.2142673,10.2162039 10.8199991,5.14389959 C10.4200597,5.43964217 10.0259396,5.7428315 9.64345796,6.05931861 L9.78470638,6.17048804 C15.9165806,10.9656667 19.5022801,18.1134882 19.7144172,25.8682203 L0.0184628081,25.8682203 C0.0121145646,26.1102399 -5.2902029e-05,26.3517275 -5.2902029e-05,26.5953428 C-5.2902029e-05,26.83949 0.0121145646,27.0809776 0.0184628081,27.3229972 L19.7144172,27.3229972 C19.5022801,35.0787931 15.9165806,42.224487 9.78470638,47.0207295 L9.64345796,47.131367 C10.0259396,47.4489179 10.4200597,47.7515753 10.8205281,48.0473179 C17.2142673,42.9744816 20.9496796,35.4654925 21.1607587,27.3229972 L25.7277909,27.3229972 L25.7277909,53.1728134 C25.9684951,53.1797282 26.2086703,53.1908983 26.4509616,53.1908983 C26.6937819,53.1908983 26.9334281,53.1797282 27.1741323,53.1728134 L27.1741323,27.3229972 L31.7411645,27.3229972 C31.9522436,35.4665563 35.6865978,42.9744816 42.0813951,48.046786 C42.4818634,47.7515753 42.8759836,47.4489179 43.2589942,47.1318989 L43.1166878,47.0207295 C36.9853426,42.2255508 33.3996431,35.0787931 33.187506,27.3229972 L52.8834604,27.3229972 C52.8903376,27.0809776 52.9019761,26.83949 52.9019761,26.5953428 C52.9019761,26.3517275 52.8903376,26.1102399 52.8834604,25.8682203 L33.187506,25.8682203 C33.3996431,18.1134882 36.9853426,10.9656667 43.1166878,6.17048804",
    id: "Fill-6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.902029,26.5955556 C52.902029,26.3514084 52.8835133,26.1115164 52.877165,25.8684331 L41.3868443,25.8684331 C41.2059194,26.3609828 41.0070078,26.84449 40.7985738,27.322678 L52.8835133,27.322678 C52.8903905,27.0806585 52.902029,26.8397028 52.902029,26.5955556",
    id: "Fill-9",
    fill: "#CCD4DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8647542,6.16969017 C41.068427,6.6452187 41.2567582,7.1287259 41.432922,7.61808412 C41.9725227,7.11702386 42.5295811,6.62926137 43.1167936,6.17022208 L43.2437585,6.07128661 C43.0252731,5.89096875 42.8083748,5.70852324 42.5840702,5.53512021 C42.4936077,5.46490795 42.4057903,5.39309995 42.3142698,5.32448341 C42.2354458,5.26544128 42.1523896,5.21118635 42.0725075,5.15267612 C41.6582846,5.4819291 41.2562292,5.82075648 40.8647542,6.16969017",
    id: "Fill-11",
    fill: "#CCD4DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1166878,47.0206231 C39.3289025,44.0584101 36.5166306,40.1972673 34.8671454,35.8499578 C34.4968312,36.2074021 34.1164656,36.5536762 33.7265776,36.8887802 C35.4696995,41.2084304 38.3078933,45.0536158 42.0813951,48.0466796 C42.4733991,47.7583838 42.8585259,47.4615774 43.2325432,47.1520051 C43.2410076,47.1450903 43.2500009,47.1387073 43.2589942,47.1317925 L43.1166878,47.0206231 Z",
    id: "Fill-13",
    fill: "#CCD4DC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(25.392974, 40.957156)",
    fill: "#CCD4DC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.78131712,0.0644144356 C1.30572788,0.273987413 0.824319416,0.473985991 0.334975648,0.655899591 L0.334975648,12.2090089 C0.5762089,12.2159238 0.81479705,12.2340087 1.05814638,12.2340087 C1.30043768,12.2340087 1.54008387,12.2223067 1.78131712,12.2159238 L1.78131712,0.0644144356 Z",
    id: "Fill-15"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.5595977,43.2198522 C14.9739722,43.197512 14.394166,43.1560229 13.8185919,43.0964489 C12.6341155,44.5278217 11.2872298,45.8458974 9.78481218,47.020889 L9.65678927,47.1203564 C9.76841255,47.2134409 9.87580367,47.3097168 9.98848499,47.4001417 C10.1260303,47.5091834 10.2651626,47.6176933 10.4042949,47.7235436 C10.5444853,47.8315216 10.6889079,47.9336485 10.8312143,48.038435 C12.6261802,46.6129132 14.2037187,44.9895205 15.5595977,43.2198522",
    id: "Fill-18",
    fill: "#CCD4DC"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntercambios);
export default __webpack_public_path__ + "static/media/intercambios.3edb24aa175b2e01522b74f001df5ecb.svg";
export { ForwardRef as ReactComponent };